import { useState } from "react";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import HeaderSwiper from "../components/Swipers/HeaderSwiper";
import AboutUs from "../components/AboutUs/AboutUs";
import LatestNewsBig from "../components/LatestNews/LatestNewsBig";
import Testimonials from "../components/Testimonials/Testimonials";
import Statistics from "../components/Statistics/Statistics";
import ThumbsSwiper from "../components/Swipers/ThumbsSwiper";
import VideoAlbum from "../components/VideoAlbum/VideoAlbum";
import TwitterIframe from "../components/TwitterIframe/TwitterIframe";
import Partnership from "../components/Partnership/Partnership";
import Footer from "../components/Footer";
import SectionContainer from "../components/SectionContainer";
import LatestNewsCards from "../components/LatestNews/LatestNewsCards";
import Container from "../components/Container";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./pages.css";
// import required modules
import { Navigation, Pagination } from "swiper/modules";
import PartnershipImage from "../components/Partnership/PartnershipImage";

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const Homepage = () => {

  const [open, setOpen] = useState(false);
  const handleSeeMore = (event) => {
    event.preventDefault();
    setOpen((prev) => !prev);
  };


  return (
    <>
      <HeaderSwiper></HeaderSwiper>
      <AboutUs></AboutUs>
      <Statistics></Statistics>
      <Partnership></Partnership>
      <Dialog open={open} onClose={setOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                    <ExclamationTriangleIcon
                      aria-hidden="true"
                      className="size-6 text-red-600"
                    />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <DialogTitle
                      as="h3"
                      className="text-base font-semibold text-gray-900"
                    >
                      صيانة
                    </DialogTitle>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">عذرا، الرابط غير متوفر حاليا.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row sm:px-6">
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpen(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  غلق
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Homepage;
